<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let fill = "#fff";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 20 20.083">
	<g>
		<g>
			<path
				d="M698.206 81.433h-18.662a.369.369 0 1 1 0-.734h18.661a.369.369 0 1 1 0 .734z"
				transform="translate(-678.875 -78.201)"
				fill={fill} />
		</g>
		<g>
			<path
				d="M693.644 101.343h-10.45a1.675 1.675 0 0 1-1.629-1.333l-3.135-13.969a.416.416 0 0 1 .3-.5.4.4 0 0 1 .485.312l3.134 13.969a.866.866 0 0 0 .842.688h10.451a.865.865 0 0 0 .842-.688l3.135-13.969a.405.405 0 0 1 .484-.312.416.416 0 0 1 .3.5l-3.134 13.969a1.676 1.676 0 0 1-1.625 1.333z"
				transform="translate(-678.419 -81.259)"
				fill={fill} />
		</g>
		<g transform="translate(8.545)">
			<circle cx="1.433" cy="1.433" fill={fill} r="1.433" />
		</g>
	</g>
	<g>
		<path
			d="M694 97.393a.367.367 0 0 1-.364-.329l-1.172-11.126a.367.367 0 1 1 .73-.077l1.172 11.126a.367.367 0 0 1-.327.4z"
			transform="translate(-686.726 -79.42)"
			fill={fill} />
	</g>
	<g>
		<path
			d="M707.448 97.392h-.039a.367.367 0 0 1-.327-.4l1.171-11.126a.367.367 0 1 1 .731.077l-1.172 11.126a.367.367 0 0 1-.364.323z"
			transform="translate(-695.373 -79.42)"
			fill={fill} />
	</g>
</svg>

<style lang="scss">
</style>
